export function convertAttributesToString (htmlAttributes: Record<string, any> = {}): string {
  return Object.keys(htmlAttributes)
    .map(attrName => `${attrName}="${htmlAttributes[attrName]}"`)
    .join(' ')
}

export function parseAttributesFromString (htmlTagString = ''): Record<string, any> {
  const attributesRegex = /\b([a-zA-Z0-9_-]+)\s*=\s*"(.*?)"/g
  const sourceAttributes: Record<string, any> = {}
  const excludedAttributes = ['onerror']

  let attrMatch = attributesRegex.exec(htmlTagString)

  while (attrMatch) {
    if (!excludedAttributes.includes(attrMatch[1])) {
      sourceAttributes[attrMatch[1]] = attrMatch[2]
    }

    attrMatch = attributesRegex.exec(htmlTagString)
  }
  return sourceAttributes
}
